import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./IndustryCollapsibleStyles.scss";
import { cx } from "@emotion/css";
import { useEffect, useRef, useState } from "react";
import { isUndefined } from "../../../FunctionsCore";
const IndustryCollapsible = (props) => {
    const { children, header, iconButtonClassName, titleClassName } = props;
    const [height, setHeight] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const reference = useRef(null);
    useEffect(() => {
        const referenceCurrent = reference.current;
        if (isUndefined(height) || !isOpen || referenceCurrent === null) {
            return void 0;
        }
        const resizeObserver = new ResizeObserver((re) => setHeight(re[0].contentRect.height));
        resizeObserver.observe(referenceCurrent);
        return () => resizeObserver.disconnect();
    }, [height, isOpen]);
    useEffect(() => {
        var _a;
        setHeight(isOpen ? (_a = reference.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height : 0);
    }, [isOpen]);
    return (_jsxs("div", { children: [_jsx("div", Object.assign({ className: cx("default-ic-card") }, { children: _jsxs("div", Object.assign({ className: cx("default-ic-header"), onClick: () => {
                        setIsOpen((bo) => !bo);
                    } }, { children: [_jsx("div", Object.assign({ className: cx(titleClassName) }, { children: header })), _jsx("button", { className: cx(iconButtonClassName, "icon-defaults", isOpen ? "rotate-center up" : "rotate-center down"), type: "button" })] })) })), _jsx("div", Object.assign({ className: cx("default-ic-content"), style: { "height": height } }, { children: _jsx("div", Object.assign({ ref: reference }, { children: _jsx("div", { children: children }) })) }))] }));
};
export { IndustryCollapsible };
